import { ApiError } from '@/lib/api/client';

/**
 * Every data view renders one of four states. Bundling them here means no
 * screen can quietly omit the empty or error case, which is the usual way an
 * admin panel ends up showing a blank page when something failed.
 */

export function Loading({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="py-12 text-center text-sm text-muted-foreground" role="status">
      {label}
    </div>
  );
}

export function Empty({ title, hint }: { title: string; hint?: string }) {
  return (
    <div className="rounded-lg border border-dashed border-border py-12 text-center">
      <p className="text-sm font-medium">{title}</p>
      {hint ? <p className="mt-1 text-sm text-muted-foreground">{hint}</p> : null}
    </div>
  );
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const isApi = error instanceof ApiError;
  return (
    <div className="rounded-lg border border-danger/40 bg-danger/5 p-4">
      <p className="text-sm font-medium text-danger">
        {isApi ? error.message : 'Something went wrong.'}
      </p>
      {isApi ? (
        <p className="mt-1 font-mono text-xs text-muted-foreground">
          {error.code}
          {error.requestId ? ` · request ${error.requestId}` : null}
        </p>
      ) : null}
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="mt-3 rounded-md border border-border px-3 py-1.5 text-sm hover:bg-muted"
        >
          Retry
        </button>
      ) : null}
    </div>
  );
}
